import React, { Component } from 'react';
import { TextInput, FullName, RadioInput } from './Form';
import { DumbField } from '../Field';
import SearchControl from './SearchControl';


export default class NameQualifiedOrg extends Component {
  constructor(props){
    super();
    this.state = {
      search: "",
      modalOpen: false,
      results: [],
      filter: "",
      loading: props.value.SOURCE_ID !== 0 && props.value.SOURCE_ID !== "0"
    };
  }
  componentDidMount = () => {
    if(this.props.isFirst){
      this.focus()
    }
  }
  selectResult = SELECTED => {
    this.props.onChange({
      ...this.props.value,
      SELECTED
    })
  }
  checkForSubmit = ({charCode}) => {
    if(charCode === 13){
      this.search()
    }
  }
  deSelect = () => {
    this.props.onChange({...this.props.value, SELECTED: null, SOURCE_ID: "0"}, {})
  }
  setFieldValue = (value, e) => {
    var val = {...this.props.value, [e.target.name]: value}
    this.props.onChange(val, {target: {name: this.props.name, value: val}})
  }
  onBlur = (value, e) => {
    this.props.onBlur(this.props.value, e);
  }
  setNameValue = (value, e) => {
    this.props.onChange({...this.props.value, ...value}, e)
  }
  getFilteredOptions = (labels) => {
    return labels.reduce((options, label, index) => {
      if(label !== ""){
        return [...options, {value: index.toString(), label}]
      }else{
        return options;
      }
    }, [])
  }
  getDefaultOrgType = (currentValue, filteredOptions) => {
    if(filteredOptions.length){
      filteredOptions.forEach(function(option){
        if(option.value === currentValue){
          return option.value;
        }
      })
      return filteredOptions[0].value;
    }
  }
  focus = () => {
    this.radio.focus()
  }
  render(){
    const {
      value,
      required,
      disabled,
      individualLabel,
      qualifiedLabel,
      unqualifiedLabel,
      modalTitle,
      qualifiedPlaceholder,
      unqualifiedPlaceholder,
      parameterFields,
      additionalParameters
    } = this.props;
    const filteredOptions = this.getFilteredOptions([
      individualLabel,
      qualifiedLabel,
      unqualifiedLabel
    ]);
    const orgType = value.ORG_TYPE.toString();
    const isOrganization = orgType === "1" || orgType === "2" ? true : false;
    return(
      <div className="block-wrapper organization-search">
        <div className="org-type">
          <RadioInput
            onChange={this.setFieldValue}
            name="ORG_TYPE"
            fieldId="ORG_TYPE"
            options={filteredOptions}
            value={orgType}
            disabled={disabled}
            leftAlign={false}
            ref={radio => { this.radio = radio }}
          />
        </div>
        <div className='dependent-field no-margin-bottom'>
          {
            isOrganization &&
            <DumbField
              label={orgType === "1" ? qualifiedLabel : unqualifiedLabel}
              required={required}
              description=""
              hideLabel={value.selected ? true : false}
            >
              {
                orgType === "1" ?
                  <div className="row">
                    <div className="col-sm-9 col-md-8 col-lg-7">
                      <SearchControl required={required}
                        searchType={this.props.searchType}
                        onChange={this.selectResult}
                        fieldLabel={qualifiedLabel}
                        modalTitle={modalTitle}
                        value={value.SELECTED ? {...value.SELECTED, SOURCE_ID: value.SOURCE_ID} : null}
                        fullWidthResult
                        placeholder={qualifiedPlaceholder}
                        disabled={disabled}
                        parameterFields={parameterFields}
                        additionalParameters={additionalParameters}
                      />
                    </div>
                  </div>
                  :
                  <div className="row">
                    <div className="col-sm-9 col-md-8 col-lg-7">
                      <TextInput {...this.props} value={value.ORG_NAME}
                        name="ORG_NAME"
                        onBlur={this.onBlur}
                        width='100%'
                        onKeyPress={this.checkForSubmit}
                        onChange={this.setFieldValue}
                        placeholder={unqualifiedPlaceholder}/>
                    </div>
                  </div>
                }
            </DumbField>
          }
          {
            orgType === '0' &&
            <div className='name-margin-override'>
              <FullName {...this.props} onChange={this.setNameValue} onBlur={this.onBlur} />
            </div>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/NameQualifiedOrg.js